import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class DjelatniciService {
  headers = new Headers();

  constructor(private _http: HttpClient) {}

  dohvatiDjelatnike(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_djelatnike', a)
      .pipe(map((res: any) => res));
  }

  dohvatiNeaktivneDjelatnike(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_neaktivne_djelatnike', a)
      .pipe(map((res: any) => res));
  }

  dohvatiMjestoRada(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_mjestorada', a)
      .pipe(map((res: any) => res));
  }

  dohvatiOrgan(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_organ_i_organnaziv', a)
      .pipe(map((res: any) => res));
  }

  dodajDjelatnika(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'spremi_djelatnika', a)
      .pipe(map((res: any) => res));
  }

  urediDjelatnika(a: any) {
    return this._http
      .put(AppConfig.ipAddress + 'uredi_djelatnika', a)
      .pipe(map((res: any) => res));
  }

  obrisiDjelatnika(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'obrisi_djelatnika', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPartnere(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_partnere', a)
      .pipe(map((res: any) => res));
  }

  uploadDjelatnika(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'upload_djelatnik_xls', a)
      .pipe(map((res: any) => res));
  }

  sinkronizirajDjelatnike(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'djelatnik_sinkronizacija', a)
      .pipe(map((res: any) => res));
  }

  dohvatiGrupeDjelatnika(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'grupe', a)
      .pipe(map((res: any) => res));
  }

  grupeModulPrava(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'grupamodulprava', a)
      .pipe(map((res: any) => res));
  }

  pravaUpdate(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'grupamodulpravaupdate', a)
      .pipe(map((res: any) => res));
  }

  dohvatiGrupeKorisnika(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'grupakorisnik', a)
      .pipe(map((res: any) => res));
  }

  grupeKorisnikaEditAdd(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'grupakorisnikspremi', a)
      .pipe(map((res: any) => res));
  }

  grupeKorisnikaEditDelete(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'grupakorisnikobrisi', a)
      .pipe(map((res: any) => res));
  }
  
}
